<template>
  <div>
    <div v-show="shopeeToken==null">
      身分未經授權<br/>請勿將此網址加入我的最愛，請至<a href="https://www.invoicego.tw/login/?next=/">發票通管理平台</a>進行身分授權或請洽管理員
      <br/>若登入再次失敗請將瀏覽器上方網址複製給管理員回報，我們將盡快協助處理問題
      <br/>
      {{this.$route.query.code !=undefined ? ('(error code:'+this.$route.query.code +')'): ''}}
    </div>
      <b-card v-show="shopeeToken!=null">
        <b-overlay :show="show" rounded="sm">
          <b-row>
            <b-col :cols="2">
              <img :src="sppngSrc" alt="Logo" style="height:40px;"/>
            </b-col>
            <b-col :cols="8">
              <b-form-group label="shopee帳號:" label-for="file-small" label-cols-sm="4">
                <b-form-input v-model="shopeeAccount"></b-form-input>
              </b-form-group>
              <b-form-group label="收發票Email:" label-for="file-small" label-cols-sm="4">
                <b-form-input v-model="email"></b-form-input>
              </b-form-group>
              <b-form-group label="賣場名稱:" label-for="file-small" label-cols-sm="4">
                <b-form-input v-model="shopName"></b-form-input>
              </b-form-group>
              <b-form-group label="月份:" label-for="file-small" label-cols-sm="4">
                <select v-model="selectedMonth" class="form-control">
                  <option v-for="month in monthOps" :value="month.value" :key="month.value">{{ month.text }}</option>
                </select>
              </b-form-group>
              <b-form-group label="開啟Excel密碼:" label-for="file-small" label-cols-sm="4">
                <b-form-input v-model="excelPwd"></b-form-input>
              </b-form-group>
              <b-form-group label="蝦皮服務費明細上傳區:" label-for="file-small" label-cols-sm="4">
                <b-form-file browse-text="選擇蝦皮Excel檔" id="orderInv" v-model="fileSpInvOrder" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" placeholder="檔案拖移此處" drop-placeholder="Drop file here..." />
              </b-form-group>
            </b-col>
            <b-col :cols="2">
              <b-button variant="success" @click="uploadShopeeInvXlsx()">上傳</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col :cols="12">
              <h3><span style="color:red;font-weight:bold;">請勿針對蝦皮檔案進行任何修改，避免引響金額正確性</span></h3>
              <h3>最近三個月上傳明細</h3>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>月份</th>
                    <!-- <th>發票號碼</th> -->
                    <!-- <th>發票日期</th> -->
                    <th>賣場名稱</th>
                    <th>總金額</th>
                    <th>下載明細</th>
                    <!-- <th>下載發票</th> -->
                    <th>刪除</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in xlsHistory" :key="item.rowId">
                    <td>{{item.month}}</td>
                    <!-- <td>{{item.invNo}}</td> -->
                    <!-- <td>{{item.invDate}}</td> -->
                    <td>{{item.shopName}}</td>
                    <td style="text-align:right;">{{(item.p1 + item.p2 + item.p3 + item.p4).toLocaleString('en-us')}}</td>
                    <td><b-button variant="success" @click="exportXlsx(item.month, item.shopName)">下載訂單明細</b-button></td>
                    <!-- <td><b-button variant="success" @click="exportInvPdf(item.month)">下載發票</b-button></td> -->
                    <td><b-button variant="danger" v-show="item.month == canDropMonth" @click="dropMonth(item.month, item.shopName)">刪除</b-button></td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-overlay>
      </b-card>
    </div>
</template>

<script>

import {
  BCard, BCardText, BCol, BRow, BFormGroup, BFormInput, BButton,BTab,BTabs,BFormFile,BOverlay,BTable,BPagination,BFormCheckbox,BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment'


export default {
  components: {
    BCol,
    BTab,
    BTabs,
    BRow,
    BCard,
    BCardText,
    BFormGroup,
    BFormInput,
    BButton,
    BOverlay,BTable,BPagination,BFormCheckbox,BAlert,
    vSelect,
    BFormFile,
  },
  data() {
    return {
      paperPrint: 'N',
      paperPrintCheckbox: ['Y'],
      shopeeToken: null,
      currentPage :1,
      pageSize :12,
      rows: 0,
      xlsHistory: [],
      show: false,
      tableBasic: [],
      name: '',
      q: {
        qInvNo: '',
        qOrderNo: '',
        qCusNo:'',
      },
      fileSpInv: null,
      fileSpInvOrder: null,
      excelPwd:'',
      fileSpIncome: null,
      token: null,
      cusNo: '83267911',
      user: {
        cusNo: '',
        userId: '',
      },
      uploadHistoryFields: [
        {key: 'fileName', label: '檔名'},
        {key: 'uploadDateDisplay', label: '上傳日期'},
        {key: 'invQty', label: '發票開立張數'},
        // {key: 'price', label: '發票銷售額'},
        // {key: 'tax', label: '發票稅額'},
        {key: 'finishIssueDateDisplay', label: '完成開立日期'},
      ],
      jsonFileName:'',
      sppngSrc:process.env.BASE_URL + '/ordertype/sp.png',
      monthOps:[],
      shopeeAccount:'',
      shopName:'',
      selectedMonth:'',
      canDropMonth:'',
      email:'',
    }
  },
  created() {
    let userData = { ability: [
      {action:'shopee',subject:'Auth'},
      // {action:'basic',subject:'Auth'},
    ]}
    this.$ability.update(userData.ability)
    // 從session來的
    let se = JSON.parse(sessionStorage.getItem('se'))
    if(se==null){
      return
    }
    this.shopeeToken = se.shopeeToken
    this.user.cusNo = se.cusNo
    this.user.userId = se.accountId
    this.q.qCusNo = se.cusNo

    let now = moment()
    // 今天日期
    let today = now.format('DD')
    let subStart = 1
    
    for(let i = 0;i<3;i++){
      now = moment()
      let sub = now.subtract(i+subStart, 'month')
      this.monthOps.push({value: sub.format('YYYYMM'), text: sub.format('YYYY年MM月')})
      if(i == 0) {
        this.canDropMonth = sub.format('YYYYMM')
      }
    }
    this.getLastUploadTitle()
  },
  methods: {
    dropMonth(month, shopName){
      // 確定要刪除月份嗎?
      this.$bvModal.msgBoxConfirm('確定要刪除此月份資料嗎?', {
        title: '確定要刪除嗎?',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: '確定',
        cancelTitle: '取消',
      }).then(value => {
        if(value) {
          let params = {month: month, shopeeToken: this.shopeeToken, shopName: shopName}
          this.$http.post('../api/shopeeInv/dropMonth', params).then(res => {
            if(res.data.msg == 'success') {
              this.getLastUploadTitle()
              alert('刪除完成')
            } else {
              alert(res.data.data)
            }
          })
        }
      }).catch(() => {
      })
    },
    parseDate(d){
      if(d!=null && d.length >= 12){
        return d.substring(4,6) + '/' +d.substring(6,8) + ' ' +d.substring(8,10) + ':'+d.substring(10,12) 
      }
      return ''
    },
    
    
    pageClick(e,page){
      this.queryInv(page)
    },
    getFormatDate(str ,type){
      if(type == 'mm/dd hh:mm') {
        if( str!= null) {
          return str.substring(4,6)+'/'+str.substring(6,8)+' '+ str.substring(8,10)+':'+str.substring(10,12)
        }
      } else if(type == 'yyyy/mm/dd hh:mm') {
        if(str!= null) {
          return str.substring(0,4)+'/'+str.substring(4,6)+'/'+str.substring(6,8)+' '+ str.substring(8,10)+':'+str.substring(10,12)
        }
      }
    },
    getLastUploadTitle(){
      let params = {
        shopeeToken: this.shopeeToken,
      }
      this.$http.get('../api/shopeeInv/getTitleInfo', { params }).then(res => {
        // 上傳最近三個月的發票明細
        for(let d of res.data.data.data){
          let invDate =  d.invDate
          if(invDate == null || invDate == '') {
          } else {
            d.invDate = invDate.substring(0,4)+'-'+invDate.substring(4,6)+'-'+invDate.substring(6,8)
          }
        }
        this.xlsHistory = res.data.data.data
        if(res.data.data.profile.length > 0) {
          this.shopeeAccount = res.data.data.profile[0].shopeeAccount
          this.email = res.data.data.profile[0].email
          this.excelPwd = res.data.data.profile[0].xlsxPwd
        }
      })
    },
    startLogForDev(){
      let params = {fileName: this.jsonFileName}
      this.$http.get('../api/shopee/startLogForDev', { params }).then(res => {
        res.data.data.forEach(e => {
          e.uploadDateDisplay = this.getFormatDate(e.uploadDate,'mm/dd hh:mm')
          
        })
        this.xlsHistory = res.data.data
      })
    },
    uploadShopeeInvXlsx(){
      // if(true){ return }

      // 檢查上傳的檔案名稱是否為order.all.yyyymmdd格式
      if(this.selectedMonth == '') {
        alert(`請選擇開立月份`)
        return
      }
      if(this.shopeeAccount == '') {
        alert(`請輸入蝦皮帳號`)
        return
      }
      if(this.email == '') {
        alert(`請輸入收發票Email`)
        return
      }
      if(this.shopName == '') {
        alert(`請輸入賣場名稱`)
        return
      }

      let fileName = this.fileSpInvOrder.name
      // console.log(fileName)
      // 每個月25日可以上傳上個月整個月份的檔案名稱
      let now = moment()
      let lastMonth = now.subtract(1, 'month')
      let lastMonthDate01 = lastMonth.startOf('month').format('YYYYMMDD')
      // 取得上個月最後一天
      let lastMonthDateLast = lastMonth.endOf('month').format('YYYYMMDD')
      let goodFileName = 'Order.all.'+lastMonthDate01+ '_' + lastMonthDateLast + '.xlsx'
      if(fileName.toLowerCase() != goodFileName.toLowerCase()) {
        alert(`請上傳上個月整個月份的檔案，檔名必須為'${goodFileName}'`)
        return
      }
      if(this.excelPwd == ''){
        alert(`請輸入蝦皮開啟excel密碼`)
        return
      }
      if(this.fileSpInvOrder == null) {
        alert(`請選擇要上傳的檔案`)
        return
      }
      
      let headers = {
        'Accpet': 'application/json',
        'content-type' : 'multipart/form-data',
        Authorization: this.token,
      }
      let user = store.state.commonParam.user
      this.formData = new FormData()
      this.formData.append('fileSpInvOrder', this.fileSpInvOrder)
      this.formData.append('shopeeToken', this.shopeeToken)
      this.formData.append('paperPrint', this.paperPrint)
      this.formData.append('pwd', this.excelPwd)
      this.formData.append('email', this.email)
      this.formData.append('month', this.selectedMonth)
      this.formData.append('shopeeAccount', this.shopeeAccount)
      this.formData.append('shopName', this.shopName)
      this.show = true
      this.$http.post('../api/shopeeInv/uploadShopeeInvXlsx', this.formData, {headers}).then(res => {
        this.show = false
        if(res.data.msg == 'success') {
          this.fileSpInvOrder  = null
          this.getLastUploadTitle()
          alert('上傳完成，請於3分鐘後返回此網頁查看上傳開立狀態')
        } else {
          alert(res.data.data)
        }
 
      }).catch(() =>{
        this.show = false
        alert('上傳錯誤')
      })
    },
    toast(toaster, append = false) {
      this.counter += 1
      this.$bvToast.toast('更新成功', {
        title: `Toaster ${toaster}`,
        toaster,
        variant: 'success',
        solid: false,
        appendToast: append,
      })
    },
    exportXlsx(month, shopName){
      let header = {xlsx:'shopeeInv'}
      header['month'] = month
      header['shopName'] = shopName
      header['cusNo'] = this.q.qCusNo
      this.q.qCusNo
      header['shopeeToken'] = this.shopeeToken
        let headers = {qp: encodeURI(JSON.stringify(header)) }
      axios.get(`../api/download/exportXlsxV2gson`,{
        method: "GET",
        responseType: 'blob',
        headers,
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        let name  = month +'-'+ shopName + '-訂單明細'
        link.setAttribute('download', name + '.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    exportPdf(month){
      let header = {xlsx:'pdf'}
      header['month'] = month
      header['shopeeToken'] = this.shopeeToken
        let headers = {qp: encodeURI(JSON.stringify(header)) }
      axios.get(`../api/download/exportPdf`,{
        method: "GET",
        responseType: 'blob',
        headers,
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        let name  = month + '訂單明細'
        link.setAttribute('download', name + '.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },

  },
  computed:{
  }
}
</script>

<style lang="scss" >
@import '~@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@/assets/scss/style.scss';

.history-table{
  border: 1px solid white;
  border-collapse: collapse;
}
// .dark-layout label {
//     font-size: 16px;
// }
</style>
